import { render, staticRenderFns } from "./separator.vue?vue&type=template&id=028214bc"
import script from "./separator.vue?vue&type=script&lang=js"
export * from "./separator.vue?vue&type=script&lang=js"
import style0 from "./separator.vue?vue&type=style&index=0&id=028214bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports